import Constants from '../../../logictry_config/constants';
import purifyhtml from '../../../logictry_purifyhtml';
import {
  getClipboardImageFiles,
  formatImageForWysiwygHtml,
} from '../utils/imagePaste';
import {
  getCaretTextOffset,
  getRootTextLength,
  setCaretFromTextOffset,
} from './caretTextOffset';
import { runExecCommand } from './execCommandLayer';
import {
  addTableColumnAfter,
  addTableColumnBefore,
  addTableRowAfter,
  addTableRowBefore,
  cleanPaste,
  createTableElement,
  expandRangeToSiblingTextRunBetweenBr,
  expandRangeToWord,
  findFormatBlockTargetFrom,
  getCurrentLinkFromRange,
  getTableCellFromSelection,
  getToolbarBlockFormatValue,
  normalizeAndGetRange,
  placeCaretAtEndOfBlock,
  rangeIntersectsLink,
  recursivelyCleanUpContentEditableHtml,
  recursivelyTraverseIfThereIsOnlyChild,
  removeEntireTable,
  removeTableColumn,
  removeTableRow,
  shouldLetBrowserHandleEnter,
  isCaretAtLogicalEnd,
  unwrapBlockFormatAtCaret,
  wrapRangeInBlockTag,
} from './editorDomUtils';

// The three different states
const HTML = 'HTML';
const SOURCE = 'SOURCE';
const BOTH = 'BOTH';

const WysiwygHtml = `<div style="background-color: white;width: 100%;height: 100%;" class="logictryWysiwygWidget">
  <style type="text/css">
    .logictryWysiwygFlex {
      display: flex;
      align-items: center;
      background-color: white;
      border-bottom: ${Constants.LightBorder};
    }
    .logictryWysiwygTextBox {
      -webkit-user-select: text;
      user-select: text;
    }
    .logictryWysiwygContent {
      position: relative;
    }
    .logictryWysiwygTextBox, .logictryWysiwygSourceText {
      width: 100%;
      height: 100%;
      padding: 12px;
      overflow: scroll;
      background-color: white;
      min-height: 200px;
      display: inline-block;
    }
    .logictryWysiwygToolbar {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .logictryWysiwygFlex i, .logictryWysiwygFlex svg {
      padding: 4px;
      font-size: 12px;
    }
    .logictryWysiwygFlex i, .logictryWysiwygFlex img, .logictryWysiwygFlex select {
      cursor: pointer;
    }
    .logictryWysiwygIcon {
      position: relative;
      height: 32px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .logictryWysiwygIcon input {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 24px;
      height: 24px;
      opacity: 0;
    }
    .logictryWysiwygDivider {
      width: 1px;
      height: 32px;
      background-color: ${Constants.LightBorderColor};
    }
    .logictryWysiwygContent {
      position: relative;
      height: calc(100% - 33px);
    }
    .logictryWysiwygSourceText {
      position: absolute;
      top: 0px;
      right: 0px;
      bottom: 0px;
    }
    .loading-container {
      position: absolute;
      inset: 0;
      border-radius: 8px;
      background: rgba(32, 33, 36, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .loading-wrapper {
      position: relative;
      min-width: 28px;
      width: 28px;
      min-height: 28px;
      height: 28px;
    }

    @keyframes circleFadeDelay {
      0%, 39%, 100% { opacity: 0; }
      40% { opacity: 1; }
    }

    .loading-circle {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transform: rotate(0deg);
    }

    .loading-circle::before {
      content: "";
      display: block;
      margin: 0 auto;
      width: 15%;
      height: 15%;
      background-color: #999; /* change color here */
      border-radius: 100%;
      animation: circleFadeDelay 1.2s infinite ease-in-out both;
    }

    .c1  { transform: rotate(0deg);   }
    .c2  { transform: rotate(30deg);  }
    .c3  { transform: rotate(60deg);  }
    .c4  { transform: rotate(90deg);  }
    .c5  { transform: rotate(120deg); }
    .c6  { transform: rotate(150deg); }
    .c7  { transform: rotate(180deg); }
    .c8  { transform: rotate(210deg); }
    .c9  { transform: rotate(240deg); }
    .c10 { transform: rotate(270deg); }
    .c11 { transform: rotate(300deg); }
    .c12 { transform: rotate(330deg); }

    .c1::before  { animation-delay: -1.2s; }
    .c2::before  { animation-delay: -1.1s; }
    .c3::before  { animation-delay: -1s;   }
    .c4::before  { animation-delay: -0.9s; }
    .c5::before  { animation-delay: -0.8s; }
    .c6::before  { animation-delay: -0.7s; }
    .c7::before  { animation-delay: -0.6s; }
    .c8::before  { animation-delay: -0.5s; }
    .c9::before  { animation-delay: -0.4s; }
    .c10::before { animation-delay: -0.3s; }
    .c11::before { animation-delay: -0.2s; }
    .c12::before { animation-delay: -0.1s; }
  </style>
  <div style="width: 100%;height: 100%;">
    <div class="logictryWysiwygFlex" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event);">
      <div class="logictryWysiwygIcon" onclick="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygToggleDocMode();">
        <svg class="logictryWysiwygCodeSVG" width="32" height="32">
          <defs>
            <linearGradient id="${HTML}" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style="stop-color: #BBB;" />
              <stop offset="50%" style="stop-color: #BBB;" />
              <stop offset="51%" style="stop-color: #BBB;" />
              <stop offset="100%" style="stop-color: #BBB;" />
            </linearGradient>
            <linearGradient id="${SOURCE}" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style="stop-color: black;" />
              <stop offset="50%" style="stop-color: black;" />
              <stop offset="100%" style="stop-color: black;" />
            </linearGradient>
          </defs>
          <g>
            <path d="M9.8 15.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0l-4.4-4.1a.8.8 0 010-1.2l4.4-4.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L6 12l3.8 3.7zM14.2 15.7c-.3.3-.3.8 0 1 .4.4.9.4 1.2 0l4.4-4.1c.3-.3.3-.9 0-1.2l-4.4-4.2a.8.8 0 00-1.2 0c-.3.3-.3.8 0 1.1L18 12l-3.8 3.7z"></path>
          </g>
        </svg>
      </div>
      <div class="logictryWysiwygDivider"></div>
      <div class="logictryWysiwygToolbar">
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'bold');">
          <svg width="32" height="32"><path d="M7.8 19c-.3 0-.5 0-.6-.2l-.2-.5V5.7c0-.2 0-.4.2-.5l.6-.2h5c1.5 0 2.7.3 3.5 1 .7.6 1.1 1.4 1.1 2.5a3 3 0 01-.6 1.9c-.4.6-1 1-1.6 1.2.4.1.9.3 1.3.6s.8.7 1 1.2c.4.4.5 1 .5 1.6 0 1.3-.4 2.3-1.3 3-.8.7-2.1 1-3.8 1H7.8zm5-8.3c.6 0 1.2-.1 1.6-.5.4-.3.6-.7.6-1.3 0-1.1-.8-1.7-2.3-1.7H9.3v3.5h3.4zm.5 6c.7 0 1.3-.1 1.7-.4.4-.4.6-.9.6-1.5s-.2-1-.7-1.4c-.4-.3-1-.4-2-.4H9.4v3.8h4z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'italic');">
          <svg width="32" height="32"><path d="M16.7 4.7l-.1.9h-.3c-.6 0-1 0-1.4.3-.3.3-.4.6-.5 1.1l-2.1 9.8v.6c0 .5.4.8 1.4.8h.2l-.2.8H8l.2-.8h.2c1.1 0 1.8-.5 2-1.5l2-9.8.1-.5c0-.6-.4-.8-1.4-.8h-.3l.2-.9h5.8z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'underline');">
          <svg width="32" height="32"><path d="M16 5c.6 0 1 .4 1 1v5.5a4 4 0 01-.4 1.8l-1 1.4a5.3 5.3 0 01-5.5 1 5 5 0 01-1.6-1c-.5-.4-.8-.9-1.1-1.4a4 4 0 01-.4-1.8V6c0-.6.4-1 1-1s1 .4 1 1v5.5c0 .3 0 .6.2 1l.6.7a3.3 3.3 0 002.2.8 3.4 3.4 0 002.2-.8c.3-.2.4-.5.6-.8l.2-.9V6c0-.6.4-1 1-1zM8 17h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'strikethrough');">
          <svg width="32" height="32" focusable="false"><g fill-rule="evenodd"><path d="M15.6 8.5c-.5-.7-1-1.1-1.3-1.3-.6-.4-1.3-.6-2-.6-2.7 0-2.8 1.7-2.8 2.1 0 1.6 1.8 2 3.2 2.3 4.4.9 4.6 2.8 4.6 3.9 0 1.4-.7 4.1-5 4.1A6.2 6.2 0 0 1 7 16.4l1.5-1.1c.4.6 1.6 2 3.7 2 1.6 0 2.5-.4 3-1.2.4-.8.3-2-.8-2.6-.7-.4-1.6-.7-2.9-1-1-.2-3.9-.8-3.9-3.6C7.6 6 10.3 5 12.4 5c2.9 0 4.2 1.6 4.7 2.4l-1.5 1.1Z"></path><path d="M5 11h14a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" fill-rule="nonzero"></path></g></svg>
        </div>
        <div class="logictryWysiwygDivider"></div>
        <div class="logictryWysiwygIcon">
          <svg width="32" height="32"><g fill-rule="evenodd"><path d="M3 18h18v3H3z"></path><path d="M8.7 16h-.8a.5.5 0 01-.5-.6l2.7-9c.1-.3.3-.4.5-.4h2.8c.2 0 .4.1.5.4l2.7 9a.5.5 0 01-.5.6h-.8a.5.5 0 01-.4-.4l-.7-2.2c0-.3-.3-.4-.5-.4h-3.4c-.2 0-.4.1-.5.4l-.7 2.2c0 .3-.2.4-.4.4zm2.6-7.6l-.6 2a.5.5 0 00.5.6h1.6a.5.5 0 00.5-.6l-.6-2c0-.3-.3-.4-.5-.4h-.4c-.2 0-.4.1-.5.4z"></path></g></svg>
          <input type="color" class="wysiwygWidgetForegroundColor" value="#000000">
        </div>
        <div class="logictryWysiwygIcon">
          <svg width="32" height="32"><g fill-rule="evenodd"><path d="M3 18h18v3H3z"></path><path fill-rule="nonzero" d="M7.7 16.7H3l3.3-3.3-.7-.8L10.2 8l4 4.1-4 4.2c-.2.2-.6.2-.8 0l-.6-.7-1.1 1.1zm5-7.5L11 7.4l3-2.9a2 2 0 012.6 0L18 6c.7.7.7 2 0 2.7l-2.9 2.9-1.8-1.8-.5-.6"></path></g></svg>
          <input type="color" class="wysiwygWidgetBackgroundColor" value="#FFFFFF">
        </div>
        <div class="logictryWysiwygDivider"></div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'justifyleft');">
          <svg width="32" height="32"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'justifycenter');">
          <svg width="32" height="32"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm3 4h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm-3-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'justifyright');">
          <svg width="32" height="32"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm6 4h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-6-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygDivider"></div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'outdent');">
          <svg width="32" height="32"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm1.6-3.8a1 1 0 01-1.2 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 011.2 1.6L6.8 12l1.8 1.2z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'indent');">
          <svg width="32" height="32"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm-2.6-3.8L6.2 12l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygDivider"></div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'insertorderedlist');">
          <svg width="32" height="32"><path d="M10 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 110-2zM6 4v3.5c0 .3-.2.5-.5.5a.5.5 0 01-.5-.5V5h-.5a.5.5 0 010-1H6zm-1 8.8l.2.2h1.3c.3 0 .5.2.5.5s-.2.5-.5.5H4.9a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2H4.5a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zM7 17v2c0 .6-.4 1-1 1H4.5a.5.5 0 010-1h1.2c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.4a.4.4 0 110-.8h1.3c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.5a.5.5 0 110-1H6c.6 0 1 .4 1 1z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'insertunorderedlist');">
          <svg width="32" height="32"><path d="M11 5h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zM4.5 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygDivider"></div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'createline');">
          <svg width="32" height="32" focusable="false"><path d="M4 11h16v2H4z" fill-rule="evenodd"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'createlink');">
          <svg width="32" height="32"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2.1 2a2 2 0 102.7 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2-2a2 2 0 10-2.6-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2z" fill-rule="nonzero"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'createimage');">
          <svg width="32" height="32"><path d="M5 15.7l3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7zM5 18V19h3l2.8-2.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm6 8a2 2 0 100-4 2 2 0 000 4z" fill-rule="nonzero"></path></svg>
        </div>
        <div class="logictryWysiwygIcon" title="Insert table" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'createtable');">
          <svg width="32" height="32" focusable="false"><path fill-rule="nonzero" d="M19 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h14ZM5 14v4h6v-4H5Zm14 0h-6v4h6v-4Zm0-6h-6v4h6V8ZM5 12h6V8H5v4Z"></path></svg>
        </div>
        <div class="logictryWysiwygDivider"></div>
        <select class="logictryTextFormatter" onmousedown="event.stopPropagation();" onchange="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, this[this.selectedIndex].value ? 'formatblock' : 'removeFormat',this[this.selectedIndex].value);this.selectedIndex=0;">
          <option selected value="">No Format</option>
          <option value="h1">Heading 1</option>
          <option value="h2">Heading 2</option>
          <option value="h3">Heading 3</option>
          <option value="p">Paragraph</option>
        </select>
        <div class="logictryWysiwygDivider"></div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'record');">
          <svg class="logictryWysiwygRecordSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" > <!-- Outer Circle --> <circle cx="12" cy="12" r="10" stroke="black" stroke-width="2" fill="none" ></circle> <!-- Inner Circle --> <circle cx="12" cy="12" stroke="black" r="6" fill="none" ></circle> </svg>
        </div>
        <div class="logictryWysiwygIcon" onmousedown="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'editcontent');">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" ><g><path fill-rule="evenodd" clip-rule="evenodd" d="M15 6.7a1 1 0 0 0-1.4 0l-9.9 10a1 1 0 0 0 0 1.3l2.1 2.1c.4.4 1 .4 1.4 0l10-9.9c.3-.3.3-1 0-1.4l-2.2-2Zm1.4 2.8-2-2-3 2.7 2.2 2.2 2.8-2.9Z"></path><path d="m18.5 7.3-.7-1.5-1.5-.8 1.5-.7.7-1.5.7 1.5 1.5.7-1.5.8-.7 1.5ZM18.5 16.5l-.7-1.6-1.5-.7 1.5-.7.7-1.6.7 1.6 1.5.7-1.5.7-.7 1.6ZM9.7 7.3 9 5.8 7.5 5 9 4.3l.7-1.5.7 1.5L12 5l-1.5.8-.7 1.5Z"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs></svg>
        </div>
        <!-- <select onchange="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'fontname',this[this.selectedIndex].value);this.selectedIndex=0;">
          <option class="heading" selected>- font -</option>
          <option>Arial</option>
          <option>Arial Black</option>
          <option>Courier New</option>
          <option>Times New Roman</option>
        </select>
        <select onchange="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'fontsize',this[this.selectedIndex].value);this.selectedIndex=0;">
          <option class="heading" selected>- size -</option>
          <option value="1">Very small</option>
          <option value="2">A bit small</option>
          <option value="3">Normal</option>
          <option value="4">Medium-large</option>
          <option value="5">Big</option>
          <option value="6">Very big</option>
          <option value="7">Maximum</option>
        </select>
        <select onchange="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'forecolor',this[this.selectedIndex].value);this.selectedIndex=0;">
          <option class="heading" selected>- color -</option>
          <option value="red">Red</option>
          <option value="blue">Blue</option>
          <option value="green">Green</option>
          <option value="black">Black</option>
        </select>
        <select onchange="this.closest('div[class=logictryWysiwygWidget]').logictryWysiwygFormatDoc(event, 'backcolor',this[this.selectedIndex].value);this.selectedIndex=0;">
          <option class="heading" selected>- background -</option>
          <option value="red">Red</option>
          <option value="green">Green</option>
          <option value="black">Black</option>
        </select> -->
      </div>
    </div>
    <div class="logictryWysiwygContent">
      <div class="logictryWysiwygTextBox" contenteditable="true"></div>
      <textarea class="logictryWysiwygSourceText" style="resize: none;"></textarea>
    </div>
  </div>
  <div class="loading-container">
    <div class="loading-wrapper">
      <div class="loading-circle c1"></div>
      <div class="loading-circle c2"></div>
      <div class="loading-circle c3"></div>
      <div class="loading-circle c4"></div>
      <div class="loading-circle c5"></div>
      <div class="loading-circle c6"></div>
      <div class="loading-circle c7"></div>
      <div class="loading-circle c8"></div>
      <div class="loading-circle c9"></div>
      <div class="loading-circle c10"></div>
      <div class="loading-circle c11"></div>
      <div class="loading-circle c12"></div>
    </div>
  </div>
</div>`;

// The three different display settings
const DISPLAY_SETTINGS = {
  SOURCE: {
    opacity: 0.1,
    pointerEvents: 'none',
    visibility: 'hidden',
    display: null,
    fill: SOURCE,
    width: '100%',
    borderLeft: null,
  },
  HTML: {
    opacity: 1,
    pointerEvents: null,
    visibility: null,
    display: 'none',
    fill: HTML,
    width: '100%',
    borderLeft: null,
  },
  BOTH: {
    opacity: 1,
    pointerEvents: null,
    visibility: null,
    display: null,
    fill: BOTH,
    width: '50%',
    borderLeft: Constants.LightBorder,
  }
}

// Setting this independently of the Wysiwyg to main the same state for all instances of Wysiwyg
let lastContentDisplaySetting = HTML;
let speechRecognition;

export default class Wysiwyg {
  constructor(_mount, _props) {
    // The mount node is the parent div that this will mount to
    this.mountNode = _mount;
    this.props = _props;
    this.contentDisplaySetting = lastContentDisplaySetting;
    this.wysiwygMount = document.createElement('div');
    this.wysiwygMount.style.width = '100%';
    this.wysiwygMount.style.height = '100%';

    // Create wrapper for mounting
    this.wrapper = document.createElement('div');
    this.wrapper.style.flex = '1';
    this.wrapper.style.border = `1px solid ${_props.borderColor || Constants.LightBorderColor}`;
    this.wrapper.style.borderRadius = `${_props.borderRadius || 16}px`;
    this.wrapper.style.overflow = 'hidden';
    this.wrapper.style.width = '100%';
    this.wrapper.style.height = '100%';

    // Mount the wysiwyg
    this.wrapper.appendChild(this.wysiwygMount);
    this.mountNode.appendChild(this.wrapper);

    // Initialize Content
    this.wysiwygMount.innerHTML = WysiwygHtml;

    this.undoStack = [];
    this.undoStackPosition = 0;
    this._historyTimer = null;

    // Initialize Html
    this.__updateHtmlTextBox(this.props.initialText);
    this.__updateSourceTextBox(this.props.initialText);

    // Initialize Busy Overlay
    this.__showBusy(false);

    // Set initial doc mode
    this.logictryWysiwygSetDocMode(this.contentDisplaySetting);

    // Add event listeners
    this.mountNode.getElementsByClassName('wysiwygWidgetForegroundColor')[0].addEventListener('input', this.foregroundHandler);
    this.mountNode.getElementsByClassName('wysiwygWidgetBackgroundColor')[0].addEventListener('input', this.backgroundHandler);
    document.addEventListener('keydown', this.keydownHandler);
    document.addEventListener('keyup', this.keyupHandler);
    document.addEventListener('mousedown', this.globalMouseDownHandler);
    this.__wysiwygWidget.addEventListener('mousedown', this.wysiwygMouseDownHandler);
    this.__htmlTextBox.addEventListener('keydown', this.keydownHandler);
    this.__htmlTextBox.addEventListener('keyup', this.keyupHandler);
    this.__sourceTextBox.addEventListener('keydown', this.keydownHandler);
    this.__sourceTextBox.addEventListener('keyup', this.keyupHandler);
    this.__htmlTextBox.addEventListener('paste', this.htmlPasteHandler);
    this.__sourceTextBox.addEventListener('paste', this.sourcePasteHandler);
    this.__htmlTextBox.addEventListener('mousedown', this.mouseDownHandler);
    this.__htmlTextBox.addEventListener('mouseup', this._onTableContextInteraction);
    this.__htmlTextBox.addEventListener('scroll', this._onTableContextScroll);
    document.addEventListener('selectionchange', this._onTableSelectionChange);
    window.addEventListener('resize', this._onResizeTableContextBar);

    setTimeout(() => this.commitHistoryIfChanged(), 0);

    // Global handlers
    this.__wysiwygWidget.logictryWysiwygFormatDoc = (e, sCmd, sValue) => {
      e.preventDefault();
      e.stopPropagation();
      if (!sCmd) return;
      if (sCmd === 'createline') {
        runExecCommand('insertHtml', false, '<hr><p><br></p>');
      } else if (sCmd === 'createlink') {
        this.createPopup({
          title: 'Create Link',
          inputs: ['Text', 'URL'],
          checkboxes: ['Open in New Tab']
        });
        return;
      } else if (sCmd === 'createimage') {
        this.createPopup({
          title: 'Create Image',
          inputs: ['URL', 'Width', 'Height'],
          checkboxes: []
        });
        return;
      } else if (sCmd === 'editcontent') {
        this.createPopup({
          title: 'Edit Content',
          textboxes: ['Prompt'],
          checkboxes: ['Only Modify Selected Content']
        });
        return;
      } else if (sCmd === 'record') {
        if ('webkitSpeechRecognition' in window && window.webkitSpeechRecognition) {
          if (speechRecognition) {
            this.mountNode.getElementsByClassName('logictryWysiwygRecordSVG')[0].children[1].style.fill = `none`;
            speechRecognition.continuous = false;
            speechRecognition.stop();
            speechRecognition = null;
          } else {
            this.mountNode.getElementsByClassName('logictryWysiwygRecordSVG')[0].children[1].style.fill = `red`;
            speechRecognition = new window.webkitSpeechRecognition();
            speechRecognition.continuous = true;
            speechRecognition.interimResults = true;
            speechRecognition.lang = 'en-US';
            speechRecognition.start();

            let finalTranscription =
              (this.__sourceTextBox.value && `${this.__sourceTextBox.value}<br>`) || '';
            speechRecognition.onresult = (event) => {
              let interimTranscription = '';
              for (let i = event.resultIndex; i < event.results.length; ++i) {
                if (event.results[i].isFinal) {
                  finalTranscription += event.results[i][0].transcript;
                } else {
                  interimTranscription += event.results[i][0].transcript;
                }
              }
              this.__updateHtmlTextBox(finalTranscription + interimTranscription);
              this.keyupHandler();
            };
            speechRecognition.onend = () => {
              if (speechRecognition && speechRecognition.continuous) {
                speechRecognition.start();
              }
            };
          }
        } else {
          alert('Web Speech API is not supported in this browser.');
        }
        return;
      } else if (sCmd === 'createtable') {
        const sel = window.getSelection();
        if (!sel?.rangeCount) return;
        const insertRange = sel.getRangeAt(0).cloneRange();
        if (getTableCellFromSelection(sel, this.__htmlTextBox)) return;
        this.createPopup({
          title: 'Insert Table',
          inputs: ['Rows', 'Columns'],
          insertRange,
        });
        return;
      } else if (sCmd === 'removeFormat') {
        const selection = window.getSelection();
        const root = this.__htmlTextBox;
        if (
          !selection ||
          !unwrapBlockFormatAtCaret(selection, root)
        ) {
          runExecCommand('removeFormat', false, null);
        }
      } else if (sCmd === 'formatblock') {
        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) return;

        const root = this.__htmlTextBox;
        const origRange = sel.getRangeAt(0).cloneRange();
        if (
          !root.contains(origRange.startContainer) ||
          !root.contains(origRange.endContainer)
        ) {
          return;
        }

        const startEl =
          origRange.startContainer.nodeType === 1
            ? origRange.startContainer
            : origRange.startContainer.parentElement;

        const baseBlock = findFormatBlockTargetFrom(startEl, root);
        const tag = sValue.toUpperCase();

        if (baseBlock) {
          if (baseBlock === root) return;
          if (baseBlock.nodeName === tag && tag !== 'P') {
            this.textChangeHandler();
            this.commitHistoryImmediate();
            setTimeout(this.updateToolbarFormatters);
            return;
          }
          const newBlock = document.createElement(tag);
          while (baseBlock.firstChild) {
            newBlock.appendChild(baseBlock.firstChild);
          }
          baseBlock.replaceWith(newBlock);
          placeCaretAtEndOfBlock(newBlock, sel);
        } else {
          let range = origRange.cloneRange();
          if (range.collapsed) {
            range = expandRangeToSiblingTextRunBetweenBr(range);
          }
          if (range.collapsed || !range.toString().trim()) return;
          wrapRangeInBlockTag(range, tag, sel);
        }

        this.textChangeHandler();
        this.commitHistoryImmediate();
        setTimeout(this.updateToolbarFormatters);
        return;
      } else {
        runExecCommand(sCmd, false, sValue);
      }
      this.textChangeHandler();
      this.commitHistoryImmediate();
      setTimeout(this.updateToolbarFormatters);
    }
    this.__wysiwygWidget.logictryWysiwygToggleDocMode = () => {
      if (this.contentDisplaySetting === HTML) this.logictryWysiwygSetDocMode(SOURCE);
      // else if (this.contentDisplaySetting === SOURCE) this.logictryWysiwygSetDocMode(BOTH);
      else this.logictryWysiwygSetDocMode(HTML);
    }
  }
  unmount = () => {
    // Remove event listeners
    this.mountNode.getElementsByClassName('wysiwygWidgetForegroundColor')[0].removeEventListener('input', this.foregroundHandler);
    this.mountNode.getElementsByClassName('wysiwygWidgetBackgroundColor')[0].removeEventListener('input', this.backgroundHandler);
    document.removeEventListener('keydown', this.keydownHandler);
    document.removeEventListener('keyup', this.keyupHandler);
    document.removeEventListener('mousedown', this.globalMouseDownHandler);
    this.__wysiwygWidget.removeEventListener('mousedown', this.wysiwygMouseDownHandler);
    this.__htmlTextBox.removeEventListener('keydown', this.keydownHandler);
    this.__htmlTextBox.removeEventListener('keyup', this.keyupHandler);
    this.__sourceTextBox.removeEventListener('keydown', this.keydownHandler);
    this.__sourceTextBox.removeEventListener('keyup', this.keyupHandler);
    this.__htmlTextBox.removeEventListener('paste', this.htmlPasteHandler);
    this.__sourceTextBox.removeEventListener('paste', this.sourcePasteHandler);
    this.__htmlTextBox.removeEventListener('mousedown', this.mouseDownHandler);
    this.__htmlTextBox.removeEventListener('mouseup', this._onTableContextInteraction);
    this.__htmlTextBox.removeEventListener('scroll', this._onTableContextScroll);
    document.removeEventListener('selectionchange', this._onTableSelectionChange);
    window.removeEventListener('resize', this._onResizeTableContextBar);
    if (this._tableContextBarDebounce) clearTimeout(this._tableContextBarDebounce);
    if (this._tableBarResizeDebounce) clearTimeout(this._tableBarResizeDebounce);
    if (this._tableContextBar) {
      this._tableContextBar.remove();
      this._tableContextBar = null;
    }
    this.onBlur(true);
    if (this.keyupTimeout) clearTimeout(this.keyupTimeout);
    if (this._historyTimer) clearTimeout(this._historyTimer);
    this.wrapper?.remove();
    this.wrapper = null;
  }
  logictryWysiwygSetDocMode(newShowWysiwyg) {
    this.contentDisplaySetting = newShowWysiwyg;
    lastContentDisplaySetting = newShowWysiwyg;
    if (newShowWysiwyg === SOURCE) this.hideTableContextBar();

    // Update the display settings to the current state;
    const { opacity, pointerEvents, visibility, display, fill, width, borderLeft } = DISPLAY_SETTINGS[this.contentDisplaySetting];
    this.__toolbar.style.opacity = opacity;
    this.__toolbar.style.pointerEvents = pointerEvents;
    this.__htmlTextBox.style.visibility = visibility;
    this.__sourceTextBox.style.display = display;
    this.__sourceTextBox.style.width = width;
    this.__htmlTextBox.style.width = width;
    this.__sourceTextBox.style.borderLeft = borderLeft;
    this.mountNode.getElementsByClassName('logictryWysiwygCodeSVG')[0].style.fill = `url(#${fill})`;

    // This property allows for setting a fixed defined height
    const { height, width: wysiwygWidth, focusOnInit } = this.props;
    this.__wysiwygWidget.style.width = wysiwygWidth;

    // Set the height and overflow
    if (height) {
      this.__htmlTextBox.style.maxHeight = height;
      this.__htmlTextBox.style.overflow = 'auto';
    } else if (this.contentDisplaySetting === SOURCE) {
      this.__htmlTextBox.style.height = '400px';
      this.__htmlTextBox.style.overflow = 'auto';
    } else {
      this.__htmlTextBox.style.height = null;
      this.__htmlTextBox.style.overflow = null;
    }

    // Set focus on content
    if (this.contentDisplaySetting === SOURCE) {
      this.__htmlTextBox.contentEditable = false;
      this.__sourceTextBox.setSelectionRange(0,0);
      if (focusOnInit) this.__sourceTextBox.focus();
    } else if (this.contentDisplaySetting === HTML) {
      this.__htmlTextBox.contentEditable = true;
      if (focusOnInit) this.__htmlTextBox.focus({ preventScroll: true });
    } else if (this.contentDisplaySetting === BOTH) {
      this.__htmlTextBox.contentEditable = true;
      if (focusOnInit) this.__htmlTextBox.focus({ preventScroll: true });
    }

    this.textChangeHandler();
  }

  commitHistoryIfChanged = () => {
    const text = this.formatHtmlTextBoxHtml();
    const caret =
      document.activeElement === this.__htmlTextBox
        ? getCaretTextOffset(this.__htmlTextBox) ?? 0
        : 0;
    const entry = { html: text, caret };

    if (this.undoStack.length === 0) {
      this.undoStack.push(entry);
      this.undoStackPosition = 0;
      return;
    }
    const top = this.normalizeHistoryEntry(this.undoStack[this.undoStackPosition]);
    if (text === top.html) return;
    this.undoStack = this.undoStack.slice(0, this.undoStackPosition + 1);
    this.undoStack.push(entry);
    this.undoStackPosition = this.undoStack.length - 1;
    const max = 80;
    while (this.undoStack.length > max) {
      this.undoStack.shift();
      this.undoStackPosition--;
    }
  };

  /** @returns {{ html: string, caret: number | null }} */
  normalizeHistoryEntry(raw) {
    if (raw != null && typeof raw === 'object' && 'html' in raw) {
      return { html: raw.html, caret: raw.caret ?? null };
    }
    return { html: String(raw), caret: null };
  }

  scheduleHistoryCommit = () => {
    clearTimeout(this._historyTimer);
    this._historyTimer = setTimeout(() => {
      this._historyTimer = null;
      this.commitHistoryIfChanged();
    }, 550);
  };

  commitHistoryImmediate = () => {
    clearTimeout(this._historyTimer);
    this._historyTimer = null;
    this.commitHistoryIfChanged();
  };

  getCurrentSourceText() {
    // 
    let flattenedText = '';
    let previousValue = '';
    this.__sourceTextBox.value.toString().split(/\r?\n/g).forEach((t, i) => {
      const nextValue = t.replace(/^\s+/g, '');
      const spacing = (i === 0 || (previousValue.endsWith('>') || (nextValue.startsWith('>') || nextValue.startsWith('<')))) ? '' : ' ';
      flattenedText = `${flattenedText}${spacing}${nextValue}`;
      previousValue = nextValue;
    })
    return flattenedText;
  }
  updateToolbarFormatters = () => {
    if (!this.__textFormatter) return;
    const sel = window.getSelection();
    if (!sel?.anchorNode) {
      this.__textFormatter.value = '';
      return;
    }
    this.__textFormatter.value = getToolbarBlockFormatValue(
      sel.anchorNode,
      this.__htmlTextBox
    );
  }
  mouseDownHandler = () => {
    setTimeout(this.updateToolbarFormatters);
    setTimeout(this.updateTableContextBar, 0);
  }

  _tableContextBarDebounce = null;
  _tableBarResizeDebounce = null;

  _onTableSelectionChange = () => {
    if (document.activeElement !== this.__htmlTextBox) return;
    clearTimeout(this._tableContextBarDebounce);
    this._tableContextBarDebounce = setTimeout(() => {
      this._tableContextBarDebounce = null;
      this.updateTableContextBar();
    }, 40);
  };

  _onTableContextInteraction = () => {
    if (document.activeElement !== this.__htmlTextBox) return;
    setTimeout(this.updateTableContextBar, 0);
  };

  _onTableContextScroll = () => {
    if (this._tableContextBar?.style.display !== 'none') this.updateTableContextBar();
  };

  _onResizeTableContextBar = () => {
    clearTimeout(this._tableBarResizeDebounce);
    this._tableBarResizeDebounce = setTimeout(() => {
      this._tableBarResizeDebounce = null;
      this.updateTableContextBar();
    }, 80);
  };

  hideTableContextBar = () => {
    if (this._tableContextBar) this._tableContextBar.style.display = 'none';
  };

  ensureTableContextBar = () => {
    if (this._tableContextBar) return this._tableContextBar;
    const content = this.mountNode.getElementsByClassName('logictryWysiwygContent')[0];
    if (!content) return null;
    const bar = document.createElement('div');
    bar.setAttribute('role', 'toolbar');
    bar.setAttribute('aria-label', 'Table');
    Object.assign(bar.style, {
      position: 'fixed',
      display: 'none',
      zIndex: '3',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '2px',
      padding: '4px 6px',
      background: Constants.White,
      border: Constants.LightBorder,
      borderRadius: '8px',
      boxShadow: '0 4px 18px rgba(0,0,0,0.12)',
      boxSizing: 'border-box',
      maxWidth: 'calc(100vw - 24px)',
    });
    const btnStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '34px',
      height: '34px',
      padding: '0',
      border: 'none',
      background: 'transparent',
      borderRadius: '4px',
      cursor: 'pointer',
      color: Constants.DarkTextColor,
      flexShrink: '0',
    };
    const toxSvg = (inner) =>
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">${inner}</svg>`;
    const mkGroup = () => {
      const g = document.createElement('div');
      Object.assign(g.style, {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '2px',
      });
      return g;
    };
    const mkGroupSep = () => {
      const d = document.createElement('div');
      Object.assign(d.style, {
        width: '1px',
        alignSelf: 'stretch',
        minHeight: '26px',
        margin: '0 10px',
        background: Constants.LightBorderColor,
        flexShrink: '0',
      });
      return d;
    };
    const mkToxBtn = (label, svgInner, onCell, opts = {}) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.title = label;
      b.setAttribute('aria-label', opts.ariaLabel || label);
      Object.assign(b.style, btnStyle);
      if (opts.danger) b.style.color = '#b00020';
      b.innerHTML = toxSvg(svgInner);
      b.addEventListener('mousedown', (e) => e.preventDefault());
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        const sel = window.getSelection();
        const c = getTableCellFromSelection(sel, this.__htmlTextBox);
        if (!c) return;
        onCell(c);
      });
      b.addEventListener('mouseenter', () => {
        b.style.background = '#f0f0f0';
      });
      b.addEventListener('mouseleave', () => {
        b.style.background = 'transparent';
      });
      return b;
    };
    const afterDomMutation = () => {
      this.textChangeHandler();
      this.commitHistoryImmediate();
      setTimeout(this.updateToolbarFormatters);
      queueMicrotask(() => this.updateTableContextBar());
    };

    // TinyMCE toolbar SVGs (fill paths), grouped like tox-toolbar__group
    const ICON_TABLE_DELETE =
      '<g fill-rule="nonzero"><path d="M20.125 18A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12c1.174 0 2.125.951 2.125 2.125v12ZM8.875 8.125h-3.75v2.75h1v1.25h-1v2.75h1v1.25h-1V18c0 .483.392.875.875.875h2.875v-1h1.25v1h3.75v-.5h1.25v.5H18a.875.875 0 0 0 .875-.875v-1.875h-.929v-1.25h.929v-2.75h-.929v-1.25h.929v-2.75h-3.75v1h-1.25v-1h-3.75v1h-1.25v-1Zm9.125-3H6A.875.875 0 0 0 5.125 6v.875h13.75V6A.875.875 0 0 0 18 5.125Z"/><path d="m14.56 10.06.88.88-2.56 2.56 2.56 2.56-.88.88L12 14.38l-2.56 2.56-.88-.88 2.56-2.56-2.56-2.56.88-.88L12 12.62z"/></g>';
    const ICON_ROW_BEFORE =
      '<g fill-rule="nonzero"><path d="M18 3.875c1.174 0 2.125.951 2.125 2.125v12A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12Zm-9.125 12.25h-3.75V18c0 .483.392.875.875.875h2.875v-2.75Zm5 0h-3.75v2.75h3.75v-2.75Zm5 0h-3.75v2.75H18a.875.875 0 0 0 .875-.875v-1.875Zm0-8H5.125v6.75h13.75v-6.75Zm-.875-3H6A.875.875 0 0 0 5.125 6v.875h13.75V6A.875.875 0 0 0 18 5.125Z"/><path d="M12.63 8.88v2h2v1.25h-2v2h-1.25v-2h-2v-1.25h2v-2z"/></g>';
    const ICON_ROW_AFTER =
      '<g fill-rule="nonzero"><path d="M18 3.875c1.174 0 2.125.951 2.125 2.125v12A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12Zm.875 9.25H5.125V18c0 .483.392.875.875.875h12a.875.875 0 0 0 .875-.875v-4.875Zm-10-5h-3.75v3.75h3.75v-3.75Zm5 0h-3.75v3.75h3.75v-3.75Zm5 0h-3.75v3.75h3.75v-3.75Zm-.875-3H6A.875.875 0 0 0 5.125 6v.875h13.75V6A.875.875 0 0 0 18 5.125Z"/><path d="M12.63 13.38v2h2v1.25h-2v2h-1.25v-2h-2v-1.25h2v-2z"/></g>';
    const ICON_ROW_DELETE =
      '<g fill-rule="nonzero"><path d="M18 3.875c1.174 0 2.125.951 2.125 2.125v12A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12Zm.875 4.25H5.125v2.75H7.5v1.25H5.125v1.75H7.5v1.25H5.125V18c0 .483.392.875.875.875h12a.875.875 0 0 0 .875-.875v-2.875H16.5v-1.25h2.375v-1.75H16.5v-1.25h2.375v-2.75Zm-.875-3H6A.875.875 0 0 0 5.125 6v.875h13.75V6A.875.875 0 0 0 18 5.125Z"/><path d="m15.06 9.56.88.88-3.06 3.06 3.06 3.06-.88.88L12 14.38l-3.06 3.06-.88-.88 3.06-3.06-3.06-3.06.88-.88L12 12.62z"/></g>';
    const ICON_COL_BEFORE =
      '<g fill-rule="nonzero"><path d="M20.125 18A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12c1.174 0 2.125.951 2.125 2.125v12Zm-15 0c0 .483.392.875.875.875h7.875V8.125h-8.75V18Zm13.75-1.875h-3.75v2.75H18a.875.875 0 0 0 .875-.875v-1.875Zm0-1.25v-2.75h-3.75v2.75h3.75Zm0-4v-2.75h-3.75v2.75h3.75ZM18 5.125H6A.875.875 0 0 0 5.125 6v.875h13.75V6A.875.875 0 0 0 18 5.125Z"/><path d="M10.13 9.88v3h3v1.25h-3v3H8.88v-3h-3v-1.25h3v-3z"/></g>';
    const ICON_COL_AFTER =
      '<g fill-rule="nonzero"><path d="M18 3.875c1.174 0 2.125.951 2.125 2.125v12A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12Zm-9.125 12.25h-3.75V18c0 .483.392.875.875.875h2.875v-2.75Zm10-8h-8.75v10.75H18a.875.875 0 0 0 .875-.875V8.125Zm-10 4h-3.75v2.75h3.75v-2.75Zm0-4h-3.75v2.75h3.75v-2.75Zm9.125-3H6A.875.875 0 0 0 5.125 6v.875h13.75V6A.875.875 0 0 0 18 5.125Z"/><path d="M15.13 9.88v3h3v1.25h-3v3h-1.25v-3h-3v-1.25h3v-3z"/></g>';
    const ICON_COL_DELETE =
      '<g fill-rule="nonzero"><path d="M18 3.875c1.174 0 2.125.951 2.125 2.125v12A2.125 2.125 0 0 1 18 20.125H6A2.125 2.125 0 0 1 3.875 18V6c0-1.174.951-2.125 2.125-2.125h12Zm0 1.25H6A.875.875 0 0 0 5.125 6v12c0 .483.392.875.875.875h12a.875.875 0 0 0 .875-.875V6A.875.875 0 0 0 18 5.125Z"/><path d="M4.5 8.13h15V6.88h-15zM8.56 10.94l6 6 .88-.88-6-6z"/><path d="m14.56 10.06-6 6 .88.88 6-6z"/><path d="m8.06 10.44 7 7 .88-.88-7-7z"/><path d="m15.06 9.56-7 7 .88.88 7-7zM9.88 7.5v2h1.25v-2zM12.88 8v1.5h1.25V8zM9.88 17.5v2h1.25v-2zM12.88 17.5v2h1.25v-2z"/></g>';

    const g2 = mkGroup();
    g2.appendChild(
      mkToxBtn('Insert row before', ICON_ROW_BEFORE, (c) => {
        addTableRowBefore(c);
        afterDomMutation();
      })
    );
    g2.appendChild(
      mkToxBtn('Insert row after', ICON_ROW_AFTER, (c) => {
        addTableRowAfter(c);
        afterDomMutation();
      })
    );
    g2.appendChild(
      mkToxBtn('Delete row', ICON_ROW_DELETE, (c) => {
        removeTableRow(c);
        afterDomMutation();
      })
    );
    const g3 = mkGroup();
    g3.appendChild(
      mkToxBtn('Insert column before', ICON_COL_BEFORE, (c) => {
        addTableColumnBefore(c);
        afterDomMutation();
      })
    );
    g3.appendChild(
      mkToxBtn('Insert column after', ICON_COL_AFTER, (c) => {
        addTableColumnAfter(c);
        afterDomMutation();
      })
    );
    g3.appendChild(
      mkToxBtn('Delete column', ICON_COL_DELETE, (c) => {
        removeTableColumn(c);
        afterDomMutation();
      })
    );
    const gDel = mkGroup();
    gDel.appendChild(
      mkToxBtn(
        'Delete table',
        ICON_TABLE_DELETE,
        (c) => {
          if (!window.confirm('Remove this entire table?')) return;
          removeEntireTable(c);
          afterDomMutation();
        }
      )
    );
    bar.appendChild(g2);
    bar.appendChild(mkGroupSep());
    bar.appendChild(g3);
    bar.appendChild(mkGroupSep());
    bar.appendChild(gDel);
    content.appendChild(bar);
    this._tableContextBar = bar;
    return bar;
  };

  updateTableContextBar = () => {
    if (!this.__htmlTextBox || this.contentDisplaySetting === SOURCE) {
      this.hideTableContextBar();
      return;
    }
    if (document.activeElement !== this.__htmlTextBox) {
      this.hideTableContextBar();
      return;
    }
    const sel = window.getSelection();
    const cell = getTableCellFromSelection(sel, this.__htmlTextBox);
    if (!cell) {
      this.hideTableContextBar();
      return;
    }
    const bar = this.ensureTableContextBar();
    if (!bar) return;
    const table = cell.closest('table');
    if (!table || !this.__htmlTextBox.contains(table)) {
      this.hideTableContextBar();
      return;
    }
    const rect = table.getBoundingClientRect();
    bar.style.display = 'flex';
    const pad = 8;
    const bh = bar.offsetHeight || 40;
    let top = rect.top - bh - 6;
    if (top < pad) top = rect.bottom + 6;
    const maxLeft = window.innerWidth - bar.offsetWidth - pad;
    const left = Math.min(Math.max(pad, rect.left), Math.max(pad, maxLeft));
    bar.style.top = `${top}px`;
    bar.style.left = `${left}px`;
  };
  wysiwygMouseDownHandler = (e) => {
    e.stopPropagation();
  }
  globalMouseDownHandler = () => {
    this.onBlur();
  }
  keydownHandler = (e) => {
    setTimeout(this.updateToolbarFormatters);
    if (e.key === 'Enter' && e.ctrlKey) return;
    if (e.key === 'Tab' || e.key === 'Escape') return;
    e.stopPropagation();
    if (e.metaKey || e.altKey) {
      if (e.key === 'u') this.__wysiwygWidget.logictryWysiwygFormatDoc(e, 'underline');
    }
    if ((e.metaKey || e.ctrlKey) && e.key === 'z' && !e.altKey) {
      e.preventDefault();
      e.stopPropagation();
      const root = this.__htmlTextBox;
      const applyEntryAtPosition = (pos) => {
        const entry = this.normalizeHistoryEntry(this.undoStack[pos]);
        this.__updateHtmlTextBox(entry.html);
        this.__updateSourceTextBox(entry.html);
        this.lastContent = entry.html;
        const len = getRootTextLength(root);
        let c = entry.caret;
        if (c == null) c = len;
        c = Math.min(Math.max(0, c), len);
        setCaretFromTextOffset(root, c);
        root.focus({ preventScroll: true });
      };
      if (e.shiftKey) {
        if (this.undoStackPosition < this.undoStack.length - 1) {
          this.undoStackPosition += 1;
          applyEntryAtPosition(this.undoStackPosition);
        }
      } else if (this.undoStackPosition > 0) {
        this.undoStackPosition -= 1;
        applyEntryAtPosition(this.undoStackPosition);
      }
    }
    if (document.activeElement === this.__htmlTextBox) {
      if (e.key === 'Enter') {
        if (e.shiftKey) return;
        const range = normalizeAndGetRange(this.__htmlTextBox);
        if (!range?.collapsed) return;

        if (shouldLetBrowserHandleEnter(range)) {
          return; // critical: do NOT preventDefault
        }

        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) return;

        const startNode =
          range.startContainer.nodeType === Node.ELEMENT_NODE
            ? range.startContainer
            : range.startContainer.parentElement;

        const inlineBoundary = startNode?.closest('b,i,u,strike,span');

        const blockBoundary = startNode?.closest('h1,h2,h3,h4,h5,p,div');

        const block =
          inlineBoundary &&
          isCaretAtLogicalEnd(range, inlineBoundary)
            ? inlineBoundary
            : blockBoundary === this.__htmlTextBox
              ? null
              : blockBoundary;

        if (!block) return;

        e.preventDefault();
        e.stopPropagation();

        const atEnd = isCaretAtLogicalEnd(range, block);

        if (atEnd) {
          if (block === this.__htmlTextBox) {
            // Root-level Enter: stay inside editor
            const br = document.createElement('br');
            range.insertNode(br);

            const newRange = document.createRange();
            newRange.setStartAfter(br);
            newRange.collapse(true);
            sel.removeAllRanges();
            sel.addRange(newRange);
          } else {
            // Real block exit
            const spacer = document.createElement('p');
            spacer.appendChild(document.createElement('br'));
            block.after(spacer);

            const newRange = document.createRange();
            newRange.setStart(spacer, 0);
            newRange.collapse(true);
            sel.removeAllRanges();
            sel.addRange(newRange);
          }
        } else {
          // normal line break inside block
          const br = document.createElement('br');
          range.insertNode(br);
          const newRange = document.createRange();
          newRange.setStartAfter(br);
          newRange.collapse(true);
          sel.removeAllRanges();
          sel.addRange(newRange);
        }
        this.textChangeHandler();
        return;
      }
      if (e.key === 'Backspace') {
        const range = normalizeAndGetRange(this.__htmlTextBox);
        if (!range?.collapsed) return;
        const selection = window.getSelection();
        if (!selection || selection.rangeCount <= 0) return;
        const currentNode = range.commonAncestorContainer;
        const topLevelNode = recursivelyTraverseupToParent(currentNode, this.__htmlTextBox);
        function recursivelyTraverseupToParent(node, htmlTextBox) {
          if (!node.parentNode) return null;
          const siblings = Array.from(node.parentNode.childNodes);
          const indexOfNode = siblings.indexOf(node);
          const previousSiblings = siblings.slice(0,indexOfNode);
          const textFound = previousSiblings.length > 0 && previousSiblings.find((s) => s.textContent.trim());
          if (node.parentNode === htmlTextBox) return node;
          if (textFound) return null;
          return recursivelyTraverseupToParent(node.parentNode, htmlTextBox);
        }
        if (range.startOffset === 0 && range.endOffset === 0 && topLevelNode && topLevelNode.previousSibling) {
          if (!topLevelNode.previousSibling.textContent.trim()) {
            e.preventDefault();
            e.stopPropagation();
            topLevelNode.previousSibling.remove();
            this.textChangeHandler();
          } else if ((topLevelNode.nodeType === Node.TEXT_NODE || ['SPAN', 'B', 'I', 'U', 'STRIKE'].includes(topLevelNode.nodeName)) && topLevelNode.previousSibling.nodeName !== '#text') {
            e.preventDefault();
            e.stopPropagation();
            topLevelNode.previousSibling.appendChild(topLevelNode);
            selection.setPosition(topLevelNode, 0);
            this.textChangeHandler();
          }
        } else if (currentNode === this.__htmlTextBox && range.startOffset !== 0 && range.startOffset === range.endOffset) {
          e.preventDefault();
          e.stopPropagation();
          const nodeToRemove = this.__htmlTextBox.childNodes[range.startOffset] || this.__htmlTextBox.childNodes[this.__htmlTextBox.childNodes.length - 1]
          selection.setPosition(nodeToRemove.previousSibling, 0);
          nodeToRemove.remove();
          this.textChangeHandler();
        }
      }
    }
  }
  keyupHandler = () => {
    if (this.keyupTimeout) clearTimeout(this.keyupTimeout)
    this.keyupTimeout = setTimeout(() => {
      this.textChangeHandler();
    }, 250);
  }
  htmlPasteHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (this.shouldHandleImagePaste(e)) {
      this.handleImagePaste(e);
      return;
    }

    const html = cleanPaste(e.clipboardData.getData('text/html') || '');
    const text = e.clipboardData.getData('text/plain') || '';
    runExecCommand(html ? 'insertHtml' : 'insertText', false, html ? html : text);
    this.textChangeHandler();
    this.commitHistoryImmediate();
  }
  shouldHandleImagePaste = (e) => {
    if (this.props.disabled) return false;
    const { imagePaste, onPasteImageFile } = this.props;
    const canUpload = onPasteImageFile || imagePaste?.uploadFile;
    if (!canUpload || imagePaste?.enabled === false) return false;
    return getClipboardImageFiles(e).length > 0;
  }
  handleImagePaste = async (e) => {
    const files = getClipboardImageFiles(e);
    if (!files.length || this._imagePasteUploading) return;

    const { imagePaste, onPasteImageFile } = this.props;
    this._imagePasteUploading = true;
    try {
      imagePaste?.onUploadStart?.();
      this.__showBusy(true);

      let url;
      if (onPasteImageFile) {
        url = await onPasteImageFile(files[0]);
      } else if (imagePaste?.uploadFile) {
        url = await imagePaste.uploadFile(files[0]);
      } else {
        return;
      }
      if (!url) throw new Error('Upload returned no URL');

      const snippet = formatImageForWysiwygHtml(url);
      runExecCommand('insertHtml', false, purifyhtml(snippet));
      this.textChangeHandler();
      this.commitHistoryImmediate();
    } catch (err) {
      if (imagePaste?.onUploadError) imagePaste.onUploadError(err);
    } finally {
      this._imagePasteUploading = false;
      this.__showBusy(false);
      imagePaste?.onUploadEnd?.();
    }
  }
  sourcePasteHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Paste the clipboardData with the current extra formatting (html)
    const text = (e.clipboardData.getData('text/plain') || '');
    const value = this.__sourceTextBox.value;

    // Save selection start and end position
    const start = this.__sourceTextBox.selectionStart;
    const end = this.__sourceTextBox.selectionEnd;
    const newValue = value.slice(0, start) + text + value.slice(end);

    // Update the value with our text inserted
    this.__sourceTextBox.value = newValue;

    // Update cursor to be at the end of insertion
    this.__sourceTextBox.selectionStart = start + text.length;
    this.__sourceTextBox.selectionEnd = this.__sourceTextBox.selectionStart;

    this.keyupHandler();
  }
  backgroundHandler = (e) => this.__wysiwygWidget.logictryWysiwygFormatDoc(e, 'backcolor', this.mountNode.getElementsByClassName('wysiwygWidgetBackgroundColor')[0].value);
  foregroundHandler = (e) => this.__wysiwygWidget.logictryWysiwygFormatDoc(e, 'forecolor', this.mountNode.getElementsByClassName('wysiwygWidgetForegroundColor')[0].value);

  onBlur = (unmounting) => {
    this.hideTableContextBar();
    if (this.popupContainer) return;
    this.textChangeHandler();
    const { removeOnBlur, onBlur } = this.props;
    if (!unmounting && removeOnBlur) this.unmount();
    if (onBlur) onBlur();
  }
  textChangeHandler = () => {
    this.__htmlTextBox.normalize();
    if (document.activeElement === this.__sourceTextBox) {
      const src = this.getCurrentSourceText();
      this.__lastSourceTextBoxValue = src;
      this.__updateHtmlTextBox(src || '');
    } else {
      this.__htmlTextBox.childNodes.forEach(recursivelyCleanUpContentEditableHtml);
      const boxed = this.formatHtmlTextBoxHtml();
      this.__lastHtmlTextBoxValue = boxed;
      this.__updateSourceTextBox(boxed);
    }

    const text = this.formatHtmlTextBoxHtml();
    if (this.lastContent === text) return;
    this.lastContent = text;
    const { onTextChanged, onRawTextChanged } = this.props;

    onTextChanged(text);
    if (onRawTextChanged) onRawTextChanged(this.__htmlTextBox.innerText);

    this.scheduleHistoryCommit();
  }
  formatHtmlTextBoxHtml = () => {
    let text = this.__htmlTextBox.innerHTML.trim().replaceAll(' style=""', '').replace(/\r?\n/g, '');
    if (text.endsWith('<br>') && !text.endsWith('<br><br>')) text = text.slice(0, -4);
    const onlyOne = recursivelyTraverseIfThereIsOnlyChild(this.__htmlTextBox);
    if (onlyOne) return '';
    return text;
  }
  changeBackgroundColor = (color) => {
    this.__htmlTextBox.style.backgroundColor = color || 'white';
  }
  changeText = (text) => {
    // If the node has been removed
    if (!this.wrapper) return;

    if (this.lastContent !== text) {
      this.lastContent = text;
      this.__updateHtmlTextBox(text);
      this.__updateSourceTextBox(text);
    }
  }

  process(str) {
    const div = document.createElement('div');
    div.innerHTML = purifyhtml(str.trim());
    return this.format(div, 0).innerHTML.replaceAll('&amp;', '&').trim();
  }
  format(node, level) {
    const indentBefore = new Array(level++ + 1).join('  ');
    const indentAfter  = new Array(level - 1).join('  ');
    let textNode;
    for (let i = 0; i < node.children.length; i += 1) {
      textNode = document.createTextNode('\n' + indentBefore);
      node.insertBefore(textNode, node.children[i]);
      this.format(node.children[i], level);
      if (node.lastElementChild === node.children[i]) {
        textNode = document.createTextNode('\n' + indentAfter);
        node.appendChild(textNode);
      }
    }
    return node;
  }
  createPopup(config) {
    this.hideTableContextBar();
    const { title, inputs, textboxes, checkboxes, insertRange } = config;
    const sel = window.getSelection();

    let range = null;
    if (title === 'Insert Table') {
      range =
        insertRange?.cloneRange?.() ??
        (sel?.rangeCount ? sel.getRangeAt(0).cloneRange() : null);
      if (!range) return;
    } else if (title === 'Edit Content') {
      range = sel?.rangeCount ? sel.getRangeAt(0) : null;
    } else {
      if (!sel || sel.rangeCount <= 0) return;
      range = sel.getRangeAt(0);
    }

    const popupLink =
      title === 'Create Link' ? getCurrentLinkFromRange(range) : null;

    if (title === 'Create Link' && !popupLink) {
      range = expandRangeToWord(range);
    }

    if (this.popupContainer) {
      this.popupContainer.remove();
      this.popupContainer = null;
    }

    // Match logictry_platform styledhtml/Tailwind (Card, Title, Form, InputBlock, Label, Input, TextArea, CheckboxRow, DialogActions, CancelButton, ConfirmButton) + Popup backdrop
    const overlay = document.createElement('div');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', title);
    Object.assign(overlay.style, {
      zIndex: '5',
      position: 'fixed',
      inset: '0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '1.5rem',
      boxSizing: 'border-box',
      backgroundColor: 'rgba(32, 33, 36, 0.6)',
    });

    const panel = document.createElement('div');
    Object.assign(panel.style, {
      background: Constants.White,
      width: '460px',
      maxWidth: '100%',
      padding: '2rem',
      borderRadius: '1rem',
      boxSizing: 'border-box',
      maxHeight: 'calc(100dvh - 6rem)',
      overflow: 'auto',
      position: 'relative',
    });
    panel.addEventListener('click', (ev) => ev.stopPropagation());

    const h = document.createElement('h2');
    Object.assign(h.style, {
      fontSize: Constants.LargeFontSize,
      fontWeight: '600',
      textAlign: 'center',
      color: Constants.DarkTextColor,
      margin: '0 0 0.5rem 0',
    });
    h.textContent = title;
    panel.appendChild(h);

    const body = document.createElement('div');
    Object.assign(body.style, {
      marginTop: '2rem',
      display: 'flex',
      flexDirection: 'column',
    });

    const inputStyleBase = {
      width: '100%',
      padding: '0.7rem 0.8rem',
      borderRadius: '0.5rem',
      border: Constants.LightBorder,
      outline: 'none',
      transition: 'border-color 0.12s ease',
      color: Constants.DarkTextColor,
      fontSize: Constants.SemiSmallFontSize,
      boxSizing: 'border-box',
    };

    const attachFieldFocus = (el) => {
      el.addEventListener('focus', () => {
        el.style.borderColor = Constants.DarkTextColor;
      });
      el.addEventListener('blur', () => {
        el.style.border = Constants.LightBorder;
      });
    };

    const mkInputBlock = () => {
      const block = document.createElement('div');
      Object.assign(block.style, {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '20px',
        position: 'relative',
      });
      return block;
    };

    const mkLabel = (text) => {
      const lb = document.createElement('label');
      Object.assign(lb.style, {
        position: 'absolute',
        top: '-8px',
        left: '8px',
        background: Constants.White,
        padding: '0 6px',
        fontSize: Constants.VerySmallFontSize,
        fontWeight: '500',
        color: Constants.MediumTextGray,
      });
      lb.textContent = text;
      return lb;
    };

    const readValues = () => {
      const values = {};
      panel.querySelectorAll('[data-wysiwyg-field]').forEach((el) => {
        const key = el.getAttribute('data-wysiwyg-field');
        if (el.type === 'checkbox') values[key] = el.checked;
        else values[key] = el.value;
      });
      return values;
    };

    let firstFocusable = null;

    inputs?.forEach((inputName) => {
      const wrap = mkInputBlock();
      wrap.appendChild(mkLabel(inputName));
      const inp = document.createElement('input');
      inp.type = 'text';
      inp.setAttribute('data-wysiwyg-field', inputName);
      inp.placeholder = inputName;
      Object.assign(inp.style, inputStyleBase);
      let defaultValue = '';
      if (title === 'Create Link' && inputName === 'Text') {
        defaultValue = popupLink
          ? popupLink.textContent || ''
          : expandRangeToWord(range)?.toString() || '';
      } else if (title === 'Create Link' && inputName === 'URL') {
        defaultValue = popupLink ? popupLink.getAttribute('href') || '' : '';
      } else if (title === 'Insert Table') {
        inp.type = 'number';
        inp.min = '1';
        inp.max = '30';
        defaultValue = '3';
      }
      inp.value = defaultValue;
      attachFieldFocus(inp);
      wrap.appendChild(inp);
      body.appendChild(wrap);
      if (!firstFocusable) firstFocusable = inp;
    });

    textboxes?.forEach((textboxName) => {
      const wrap = mkInputBlock();
      wrap.appendChild(mkLabel(textboxName));
      const ta = document.createElement('textarea');
      ta.setAttribute('data-wysiwyg-field', textboxName);
      ta.placeholder = textboxName;
      Object.assign(ta.style, {
        ...inputStyleBase,
        fontFamily: 'inherit',
        resize: 'vertical',
        minHeight: '160px',
      });
      attachFieldFocus(ta);
      wrap.appendChild(ta);
      body.appendChild(wrap);
      if (!firstFocusable) firstFocusable = ta;
    });

    checkboxes?.forEach((checkboxName) => {
      let checked = false;
      if (title === 'Edit Content') {
        const fragment = range?.cloneContents();
        if (fragment) {
          const div = document.createElement('div');
          div.appendChild(fragment);
          checked = div.innerHTML.trim().length > 0;
        }
      } else if (title === 'Create Link') {
        checked = true;
      }
      const row = document.createElement('label');
      Object.assign(row.style, {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        fontSize: Constants.SemiSmallFontSize,
        color: Constants.LightTextGray,
        cursor: 'pointer',
        userSelect: 'none',
        marginBottom: '16px',
      });
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = checked;
      cb.setAttribute('data-wysiwyg-field', checkboxName);
      Object.assign(cb.style, { width: '16px', height: '16px', cursor: 'pointer' });
      const span = document.createElement('span');
      span.textContent = checkboxName;
      row.appendChild(cb);
      row.appendChild(span);
      body.appendChild(row);
    });

    const actions = document.createElement('div');
    Object.assign(actions.style, {
      marginTop: '2rem',
      display: 'flex',
      justifyContent: 'space-evenly',
      gap: '1rem',
    });

    const btnCancel = document.createElement('button');
    btnCancel.type = 'button';
    btnCancel.textContent = 'Cancel';
    Object.assign(btnCancel.style, {
      padding: '0.75rem',
      borderRadius: '0.5rem',
      border: Constants.LightBorder,
      cursor: 'pointer',
      fontWeight: '550',
      width: '100%',
      background: '#fafafa',
      color: Constants.LightTextGray,
      fontSize: Constants.SemiSmallFontSize,
      boxSizing: 'border-box',
    });
    btnCancel.addEventListener('mouseenter', () => {
      btnCancel.style.background = '#f0f0f0';
    });
    btnCancel.addEventListener('mouseleave', () => {
      btnCancel.style.background = '#fafafa';
    });

    const createButtonText =
      title === 'Edit Content' ? 'Modify' : title === 'Insert Table' ? 'Insert' : 'Create';
    const showPrimary = true;
    const btnPrimary = document.createElement('button');
    btnPrimary.type = 'button';
    btnPrimary.textContent = createButtonText;
    Object.assign(btnPrimary.style, {
      padding: '0.75rem',
      borderRadius: '0.5rem',
      border: 'none',
      cursor: 'pointer',
      fontWeight: '600',
      width: '100%',
      background: Constants.DarkTextColor,
      color: Constants.White,
      fontSize: Constants.SemiSmallFontSize,
      boxSizing: 'border-box',
    });
    btnPrimary.addEventListener('mouseenter', () => {
      btnPrimary.style.background = '#000';
    });
    btnPrimary.addEventListener('mouseleave', () => {
      btnPrimary.style.background = Constants.DarkTextColor;
    });

    const close = () => {
      document.removeEventListener('keydown', onKeyDown);
      overlay.remove();
      if (this.popupContainer === overlay) this.popupContainer = null;
    };

    const onKeyDown = (ev) => {
      if (ev.key === 'Escape') {
        ev.preventDefault();
        close();
      }
    };

    const applyPopupAction = async () => {
      const values = readValues();
      close();
      this.__htmlTextBox.focus({ preventScroll: true });

      if (title === 'Create Link') {
        if (!values.URL) return;

        const newHref = values.URL.trim();
        const newText = (values.Text || '').trim();
        const openNewTab = !!values['Open in New Tab'];

        if (popupLink) {
          popupLink.setAttribute('href', newHref);

          if (openNewTab) {
            popupLink.setAttribute('target', '_blank');
            popupLink.setAttribute('rel', 'noopener noreferrer');
          } else {
            popupLink.removeAttribute('target');
            popupLink.removeAttribute('rel');
          }

          if (newText && newText !== popupLink.textContent) {
            popupLink.textContent = newText;
          }

          const after = document.createRange();
          after.setStartAfter(popupLink);
          after.collapse(true);
          sel.removeAllRanges();
          sel.addRange(after);
        } else {
          const workingRange = expandRangeToWord(range);
          if (!workingRange) return;

          const link = document.createElement('a');
          link.setAttribute('href', newHref);

          if (openNewTab) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
          }

          if (rangeIntersectsLink(workingRange)) {
            const t = workingRange.toString().trim();
            if (!t) return;

            link.textContent = t;
            workingRange.deleteContents();
            workingRange.insertNode(link);
          } else if (!workingRange.collapsed && workingRange.toString().trim()) {
            const contents = workingRange.extractContents();
            link.appendChild(contents);
            workingRange.insertNode(link);
          } else {
            link.textContent = newText || newHref;
            workingRange.insertNode(link);
          }

          const after = document.createRange();
          after.setStartAfter(link);
          after.collapse(true);
          sel.removeAllRanges();
          sel.addRange(after);
        }
      } else if (title === 'Insert Table') {
        let rows = parseInt(values.Rows, 10);
        let cols = parseInt(values.Columns, 10);
        if (!Number.isFinite(rows) || rows < 1) rows = 3;
        if (!Number.isFinite(cols) || cols < 1) cols = 3;
        rows = Math.min(30, Math.max(1, rows));
        cols = Math.min(30, Math.max(1, cols));
        const table = createTableElement(rows, cols);
        range.deleteContents();
        range.insertNode(table);
        const firstTd = table.querySelector('td');
        if (firstTd) {
          const r = document.createRange();
          r.selectNodeContents(firstTd);
          r.collapse(true);
          const s = window.getSelection();
          s.removeAllRanges();
          s.addRange(r);
        }
      } else if (title === 'Create Image') {
        if (!values.URL) return;
        const image = document.createElement('img');
        image.src = values.URL;
        if (values.Width) image.width = values.Width;
        if (values.Height) image.height = values.Height;
        range.deleteContents();
        range.insertNode(image);
      } else if (title === 'Edit Content') {
        this.__showBusy(true);
        const onlySelectedContent = values['Only Modify Selected Content'];
        let content;
        if (onlySelectedContent) {
          const fragment = range.cloneContents();
          const div = document.createElement('div');
          div.appendChild(fragment);
          content = div.innerHTML;
        } else {
          content = this.getCurrentSourceText();
        }

        const csrfToken = document.querySelector('meta[name="csrf-token"]');
        const res = await fetch(`${window.location.origin}/v1/openai`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(csrfToken ? { 'csrf-token': csrfToken.content } : {}),
          },
          body: JSON.stringify({
            action: 'EditContent',
            prompt: values.Prompt,
            content,
          }),
        });
        let html = await res.text();
        html = html.replace(/\r?\n/g, '');

        if (onlySelectedContent) {
          range.deleteContents();
          const div = document.createElement('div');
          div.innerHTML = html;
          const nodes = Array.from(div.childNodes);
          nodes.reverse().forEach((node) => range.insertNode(node));
        } else {
          this.__updateHtmlTextBox(html);
        }
        this.__showBusy(false);
      }
      this.textChangeHandler();
      this.commitHistoryImmediate();
    };

    btnCancel.addEventListener('click', close);
    btnPrimary.addEventListener('click', () => {
      applyPopupAction();
    });

    overlay.addEventListener('click', (ev) => {
      if (ev.target === overlay) close();
    });

    actions.appendChild(btnCancel);
    if (showPrimary) actions.appendChild(btnPrimary);
    panel.appendChild(body);
    panel.appendChild(actions);
    overlay.appendChild(panel);

    document.addEventListener('keydown', onKeyDown);
    this.popupContainer = overlay;
    document.body.appendChild(overlay);
    const focusEl = firstFocusable || btnCancel;
    setTimeout(() => focusEl?.focus?.(), 0);
  }
  __updateSourceTextBox(text) {
    this.__sourceTextBox.value = this.process(text);
    this.__lastSourceTextBoxValue = this.getCurrentSourceText();
  }
  __updateHtmlTextBox(text) {
    this.__htmlTextBox.innerHTML = purifyhtml(text);
    this.__lastHtmlTextBoxValue = this.__htmlTextBox.innerHTML;
  }
  __showBusy(busy) {
    this.__loadingContainer.style.display = busy ? 'flex' : 'none';
  }
  get __wysiwygWidget() {
    return this.mountNode.getElementsByClassName('logictryWysiwygWidget')[0];
  }
  get __htmlTextBox() {
    return this.mountNode.getElementsByClassName('logictryWysiwygTextBox')[0];
  }
  get __sourceTextBox() {
    return this.mountNode.getElementsByClassName('logictryWysiwygSourceText')[0];
  }
  get __toolbar() {
    return this.mountNode.getElementsByClassName('logictryWysiwygToolbar')[0];
  }
  get __textFormatter() {
    return this.mountNode.getElementsByClassName('logictryTextFormatter')[0];
  }
  get __loadingContainer() {
    return this.mountNode.getElementsByClassName('loading-container')[0];
  }
}
